query LeadResearchPromptQuery {
    leadResearchPrompt {
        selectedFields
        businessContext
        idealCustomer
        availableFields {
            key
            label
        }
    }
}
